import PropTypes from "prop-types";
import SignType from "../../../../domain/signType";
import SignTypeBadge from "../../../../components/SignTypeBadge";
import ImageCarousel from "./ImageCarousel";
import s from "./ProductImage.module.css";

ProductImage.propTypes = {
  product: PropTypes.object.isRequired,
  customerImage: PropTypes.shape({ imageUrl: PropTypes.string }),
  signedType: PropTypes.string,
  soldOut: PropTypes.bool,
  isVaulted: PropTypes.bool,
};

export default function ProductImage({
  product,
  customerImage,
  signedType,
  soldOut,
  isVaulted,
}) {
  const type = signedType || product.signed_type;
  const hasCustomerImage = Boolean(customerImage?.imageUrl);
  const hasMultipleImages = !hasCustomerImage && product.images?.length > 1;

  const wrapClass = [
    s.imageWrap,
    hasMultipleImages ? s.imageWrapCarousel : "",
    soldOut ? s.imageGrayscale : isVaulted ? s.imageDesaturate : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={wrapClass}>
      {type && (
        <div className={s.badgeWrap}>
          <SignTypeBadge signedType={type} label={SignType.toLabel(type)} />
        </div>
      )}

      {hasMultipleImages ? (
        <ImageCarousel
          images={product.images}
          productName={product.name || "Product"}
        />
      ) : (
        <img
          className={s.productImg}
          src={hasCustomerImage ? customerImage.imageUrl : product.image_url}
          alt={product.name || "Product"}
          loading="eager"
          decoding="async"
          width={600}
          height={Math.round(600 / (product.aspect_ratio || 1))}
        />
      )}
    </div>
  );
}
